// extracted by mini-css-extract-plugin
export var activeFilterButton = "_lx-c";
export var backButton = "_lx-4";
export var backIcon = "_lx-5";
export var chevronShortcut = "_lx-6";
export var container = "_lx-1";
export var editor = "_lx-8";
export var editorWrapper = "_lx-7";
export var prefix = "_lx-2";
export var searchIcon = "_lx-3";
export var suffix = "_lx-9";
export var suffixContent = "_lx-a";
export var suffixText = "_lx-b";
export var wrapper = "_lx-0";